import { useDispatch } from "react-redux";
import { setCountryAction } from "../redux/features/country";

const DEFAULT_COUNTRY = "SV";
export const SV = "SV";
export const GT = "GT";
export const PA = "PA";

const availableCountries = [SV, GT, PA];

export interface CountryStorage {
  country: string;
}

export const useUserCountry = () => {
  const dispatch = useDispatch();

  const setCountry = (countryCode: string): CountryStorage | null => {
    if (!availableCountries.includes(countryCode.toUpperCase())) {
      return null;
    }
    const storage: CountryStorage = {
      country: countryCode,
    };
    dispatch(setCountryAction(storage));
    const countryJson = JSON.stringify(storage);
    localStorage.setItem("c", countryJson);
    return storage;
  };

  const getCurrentCountry = (): CountryStorage | null => {
    const currentCountry = localStorage.getItem("c") || null;
    if (!currentCountry) {
      return {
        country: DEFAULT_COUNTRY,
      };
    }
    const { country: countryCode } = JSON.parse(currentCountry);
    return {
      country: countryCode,
    };
  };

  const getServiceUrlCountry = (): string => {
    const currentCountry = getCurrentCountry();
    const domainSv = process.env.REACT_APP_API_URL || "na-sv";
    const domainGt = process.env.REACT_APP_API_URL_GT || "na-gt";
    const domainPa = process.env.REACT_APP_API_URL_PA || "na-pa";
    if (!currentCountry) {
      console.error("Current country process was not found");
      return "";
    }
    return currentCountry.country.toUpperCase() === SV
      ? domainSv
      : currentCountry.country.toUpperCase() === GT
      ? domainGt
      : domainPa;
  };

  return {
    setCountry,
    getCurrentCountry,
    getServiceUrlCountry,
  };
};

export default useUserCountry;
